import { render, staticRenderFns } from "./ResidentCareimageRow.vue?vue&type=template&id=f65ce46c&scoped=true&lang=pug"
import script from "./ResidentCareimageRow.vue?vue&type=script&lang=ts"
export * from "./ResidentCareimageRow.vue?vue&type=script&lang=ts"
import style0 from "./ResidentCareimageRow.vue?vue&type=style&index=0&id=f65ce46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65ce46c",
  null
  
)

export default component.exports